export default "__VITE_ASSET__ChvHUAN9__"